import Helpers from "@/services/helpers";
import { SET_REPEAT } from "@/store/mutation-types";

export default {
  name: "repeat",
  install(ctx) {
    Helpers.mapStore(ctx, {
      repeat: {
        get: "player/repeat",
        set: `player/${SET_REPEAT}`
      }
    });

    const toggle = function(target) {
      const values = ["none", "playlist", "track"];
      const index = values.findIndex(item => item === this.repeat);

      if (target && values.includes(target)) {
        this.repeat = target;
      } else {
        this.repeat = values[index >= values.length - 1 ? 0 : index + 1];
      }
    };

    return {
      toggle: toggle.bind(ctx)
    };
  }
};
